import { render, staticRenderFns } from "./Specials.vue?vue&type=template&id=3a77233b&scoped=true&"
import script from "./Specials.vue?vue&type=script&lang=js&"
export * from "./Specials.vue?vue&type=script&lang=js&"
import style0 from "./Specials.vue?vue&type=style&index=0&id=3a77233b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a77233b",
  null
  
)

export default component.exports